import ViewInSpaceModal from './ViewInSpaceModal';

export default ViewInSpaceModal;
